export default __webpack_public_path__ + "static/media/royale.7562463b.jpeg";